import React from 'react';
import { Translations } from '../i18n/translations';
import { WhatsAppIcon } from './icons';
interface HeroProps {
  t: Translations;
  setPage: (page: 'home' | 'product') => void;
}
export const Hero: React.FC<HeroProps> = ({
  t,
  setPage
}) => {
  return <section className="relative w-full min-h-[70vh] lg:min-h-[80vh] flex items-center bg-beige overflow-hidden" data-id="element-127">
      {/* Background Image / Gradient */}
      <div className="absolute inset-0 z-0" data-id="element-128">
        <div className="absolute inset-0 bg-gradient-to-r from-beige via-beige/90 to-transparent z-10" data-id="element-129"></div>
        <img src="https://images.unsplash.com/photo-1594744803329-e58b31de8bf5?q=80&w=2000&auto=format&fit=crop" alt="Premium Shapewear" className="w-full h-full object-cover object-right lg:object-center opacity-80" data-id="element-130" />
      </div>

      <div className="relative z-20 max-w-7xl mx-auto px-4 lg:px-8 w-full" data-id="element-131">
        <div className="max-w-xl flex flex-col items-start" data-id="element-132">
          <h1 className="text-5xl lg:text-7xl font-serif text-ink leading-tight mb-6" data-id="element-133">
            {t.hero.headline}
          </h1>

          <p className="text-lg lg:text-xl text-ink/80 mb-10 max-w-md font-light leading-relaxed" data-id="element-134">
            {t.hero.subtitle}
          </p>

          <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4 w-full sm:w-auto" data-id="element-135">
            <button onClick={() => setPage('product')} className="bg-gold text-ink px-8 py-4 text-sm tracking-widest uppercase hover:bg-gold-dark transition-soft rounded-sm font-medium text-center" data-id="element-136">
              {t.hero.shopNow}
            </button>
            <button className="border border-gold text-gold px-8 py-4 text-sm tracking-widest uppercase hover:bg-gold hover:text-ink transition-soft rounded-sm flex items-center justify-center space-x-2" data-id="element-137">
              <WhatsAppIcon className="w-5 h-5" data-id="element-138" />
              <span data-id="element-139">{t.hero.whatsapp}</span>
            </button>
          </div>
        </div>
      </div>
    </section>;
};